<template>
  <div class="head">
    <div class="inner">
      <a
        class="social twitt"
        target="_blank"
        href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fforbes.hu%2Fextra%2Fcsaladi-lista-2019%2F&text=Forbes%20Csal%C3%A1di%20Lista%202019"
        title="Megosztás a Twitteren"
      ><img
          src="../assets/twitter-icon.svg"
          alt="Twitter"
        ></a>
      <a
        class="social face"
        target="_blank"
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fforbes.hu%2Fextra%2Fcsaladi-lista-2019%2F"
        title="Megosztás a Facebookon"
      ><img
          src="../assets/facebook-icon.svg"
          alt="Facebook"
        ></a>
      <a
        class="social insta"
        target="_blank"
        href="https://www.instagram.com/forbeshungary/"
        title="Forbes az Instagramon"
      ><img
          src="../assets/instagram-icon.svg"
          alt="Instagram"
        ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadComponent',
  props: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped lang="css">
.head {
  background-color: #fff;
  color: #0a0a0a;
}
.inner {
  height: 48px;
  display: flex;
  padding-left: 20px;
  flex-wrap: nowrap;
  align-items: center;
}
.social {
  margin: 0 10px;
}
.social img {
  height: 25px;
}
</style>
